
export function getUrlClass() {
  return URL;
}

